<div *ngIf="menu" class="footer">
  <button mat-button *ngFor="let item of menu; last as isLast" [routerLink]="item.link">
    <span *ngIf="item.icon">
      <mat-icon>{{ item.icon }}</mat-icon>
    </span>
    {{ item.label }}
  </button>
</div>
